import React, { useState } from "react";
import { Text, Button, TextArea, Img, Input, Heading } from "./..";
import { toast, ToastContainer } from "react-toastify";

const Footer = ({ ...props }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Email is invalid.";
    if (!formData.message) newErrors.message = "Message is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {

      console.log("State form data is ", formData);
      // Implement email sending here if needed.
      const actualformData = new FormData();
      actualformData.append('name', formData.name);
      actualformData.append('email', formData.email);
      actualformData.append('message', formData.message);

      console.log("Actual Formdata is ", actualformData);

      // Send data to PHP via fetch
      fetch('/New-Zwilling-Website-PHP/send_email.php', {
        method: 'POST',
        body: actualformData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'success') {
            toast.success("Thank you for getting in touch!");
          } else {
            toast.error(`Error: ${data.message}`);
          }
        })
        .catch((error) => {
          console.error('Error sending email:', error);
          toast.error('Something went wrong, please try again later.');
        });
    }
  };

  return (
    <footer
      {...props}
      className={`${props.className} flex flex-col px-[15%] py-[15%] items-center w-full`}
    >
      <div className="flex flex-col md:flex-row px-10 pt-6 items-start justify-between w-full gap-[38px]">
        {/* Zwilling Labs Section */}
        <div className="flex flex-col gap-[76px] md:w-[30%] sm:w-full">
          <div className="flex flex-col gap-[50px]">
            <div className="flex gap-1.5 items-center">
              <Img
                src="/images/img_thumbs_up.svg"
                alt="Thumbs Up Image"
                className="h-[72px] object-contain md:h-[50px]"
              />
              <Heading
                size="heading14xl"
                as="h1"
                className="font-dmsans text-[38px] font-black text-color_style-01_neutrals-grey50 md:text-[36px] sm:text-[24px]"
              >
                Zwilling Labs
              </Heading>
            </div>
            <ul className="flex flex-col gap-5">
              <li>
                <a href="/blogs" className="sm:text-[16px]">
                  <Heading
                    size="text7xl"
                    as="p"
                    className="text-[20px] font-normal text-color_style-01_neutrals-grey50 underline"
                  >
                    Case Studies
                  </Heading>
                </a>
              </li>
              <li>
                <a href="/blogs" rel="noreferrer" className="sm:text-[16px]">
                  <Heading
                    size="text7xl"
                    as="p"
                    className="text-[20px] font-normal text-color_style-01_neutrals-grey50 underline"
                  >
                    Blogs
                  </Heading>
                </a>
              </li>
              <li>
                <a href="/privacypolicy" className="sm:text-[16px]">
                  <Heading
                    size="text7xl"
                    as="p"
                    className="text-[20px] font-normal text-color_style-01_neutrals-grey50 underline"
                  >
                    Privacy policy
                  </Heading>
                </a>
              </li>
            </ul>
            <div className="flex flex-col items-start gap-3">
              <Heading
                size="heading10xl"
                as="h3"
                className="text-[30px] font-bold text-color_style-01_neutrals-grey50 md:text-[28px] sm:text-[18px]"
              >
                Follow Us
              </Heading>
              <div className="flex items-center gap-[22px]">
                <a href="https://in.linkedin.com/company/zwillinglabs">
                  <Img src="/images/img_linkedin.svg" alt="Info Icon" className="h-[24px]" />
                </a>
                <Img src="/images/img_info.svg" alt="Info Icon" className="h-[24px]" />
                <Img src="/images/img_facebook.svg" alt="Facebook Icon" className="h-[26px]" />
              </div>
            </div>
          </div>
        </div>

        {/* Contact Info Section */}
        <div className="flex flex-col gap-[26px] md:w-[30%] sm:w-full">
          <Heading
            size="heading10xl"
            as="h3"
            className="font-montserrat text-[30px] font-semibold text-color_style-01_neutrals-grey100 md:text-[28px] sm:text-[18px]"
          >
            Contact info
          </Heading>
          <div className="flex flex-col gap-9">
            <a href="https://maps.app.goo.gl/VpEtikw2wvETQLbB6" target="_blank" rel="noreferrer">
              <div className="flex items-start gap-3">
                  <Img src="/images/img_akar_icons_location.svg" alt="Location Icon" className="h-[30px]" />
                  <Heading
                    size="text7xl"
                    as="p"
                    className="w-[88%] text-[20px] font-medium text-color_style-01_neutrals-grey50 sm:text-[16px]"
                  >
                    6031B, 6th floor
                    <br />
                    Rahul Bajaj Technology Innovation Center
                    <br />
                    IIT Bombay, Powai
                    <br />
                    Mumbai 400076
                  </Heading>
              </div>
            </a>
            <a href="tel:+918144581900">
              <div className="flex items-center gap-4">
                <Img src="/images/img_call.svg" alt="Phone Icon" className="h-[22px]" />
                <Heading
                  size="text7xl"
                  as="p"
                  className="text-[20px] font-normal text-color_style-01_neutrals-grey50 sm:text-[16px]"
                >
                  +91 8144581900
                </Heading>
              </div>
            </a>
            <a href="mailto:business@zwillinglabs.ai">
              <div className="flex items-start gap-3">
                <Img src="/images/img_lock.svg" alt="Email Icon" className="h-[20px]" />
                <Heading
                  size="text7xl"
                  as="p"
                  className="text-[20px] font-normal text-color_style-01_neutrals-grey50 sm:text-[16px]"
                >
                  business@zwillinglabs.ai
                </Heading>
              </div>
            </a>
            
          </div>
        </div>

        {/* Contact Us Form */}
        <div className="flex flex-col gap-[18px] md:w-[30%] sm:w-full">
          <Heading
            size="heading10xl"
            as="h3"
            className="text-[30px] font-bold text-color_style-01_neutrals-grey50 md:text-[28px] sm:text-[18px]"
          >
            Get in touch
          </Heading>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <Input
                shape="round"
                name="name"
                placeholder="Your name"
                value={formData.name}
                onChange={handleChange}
                className={`rounded-[12px] border-[1.33px] px-5 ${
                  errors.name ? "border-red-500" : "border-gray-200_01"
                }`}
              />
              {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
            </div>
            <div>
              <Input
                shape="round"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                className={`rounded-[12px] border-[1.33px] px-5 ${
                  errors.email ? "border-red-500" : "border-gray-200_01"
                }`}
              />
              {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
            </div>
            <div>
              <TextArea
                shape="round"
                name="message"
                placeholder="Your message"
                value={formData.message}
                onChange={handleChange}
                className={`rounded-[16px] !border-[1.33px] bg-white px-5 w-full ${
                  errors.message ? "border-red-500" : "border-gray-200_01"
                }`}
              />
              {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
            </div>
            <Button
              size="4xl"
              shape="round"
              type="submit"
              className="min-w-[164px] rounded-[12px] px-[34px] font-bold tracking-[-0.72px]"
            >
              Send
            </Button>
            <ToastContainer position="top-right" />
          </form>
        </div>
      </div>

      <Text as="p" className="mt-[30px] font-mulish text-[18.66px] font-medium text-white sm:text-center sm:text-[18px]">
        Copyright © 2025 Zwilling Labs Pvt. Ltd. | All Rights Reserved
      </Text>
    </footer>
  );
};

export default Footer;
